/* global HTMLAuxSelectElement, HTMLAuxRadioElement */
import "./insRadioGroup.scss";
import { AuxRadio, AuxSelect } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import React, { createRef } from "react";
export const InsRadioGroup = (props) => {
    const selectRef = Array.from({ length: props.data.length }, () => createRef());
    const radioRef = Array.from({ length: props.data.length }, () => createRef());
    const handleRadioChange = (event) => {
        const lineIndex = event.detail.value.eventData?.index;
        if ((lineIndex || lineIndex === 0) && !isNaN(lineIndex) && selectRef[lineIndex].current) {
            event.detail.value.eventData = {
                filter: event.detail.value.eventData?.filter || "",
                quantity: Number((selectRef[lineIndex].current?.selected).value)
            };
            props.onRadioChanged(event);
        }
        else {
            delete event.detail.value.eventData?.index;
            props.onRadioChanged(event);
        }
    };
    const handleSelectionChange = (event) => {
        const lineIndex = Number(event.target?.id);
        if ((lineIndex || lineIndex === 0) && !isNaN(lineIndex) && radioRef[lineIndex]?.current?.isChecked) {
            const returnedEvent = event;
            returnedEvent.detail.value = { ...event.detail.value,
                eventData: {
                    filter: radioRef[lineIndex].current?.eventData.filter,
                    quantity: Number(event.detail.value.value)
                } };
            props.onRadioChanged(returnedEvent);
        }
    };
    return React.createElement("div", null,
        React.createElement("div", { className: `insRadioGroupLabel ${props.isHeaderBold ? "insRadioGroupLabelBold" : ""}` }, props.label),
        props.data.map((radioInterface, index) => React.createElement("div", { className: "insRadioGroupSelectDiv", key: index },
            React.createElement(AuxRadio, { className: index === 0 ? "" : "insRadioBox", ref: radioRef[index], label: radioInterface.label, eventData: { ...radioInterface.eventData, index }, isChecked: radioInterface.checked, isDisabled: props.disabled, onRadioChanged: handleRadioChange }),
            radioInterface.selectData && React.createElement(AuxSelect, { onSelectionChanged: handleSelectionChange, ref: selectRef[index], hasInitialOptionPlaceholder: false, id: index.toString(), isDisabled: props.disabled, className: "insRadioGroupSelectWidth", size: AuxButtonSizeEnum.SMALL, data: radioInterface.selectData }))));
};
